import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var SearchPointOfSalesCtrl = function (fn, er, token, ids, page, filter) {

	
	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},

	};
	var data = {
		orderBy: "",
		page: page,
		filter: filter === undefined ? '' : filter.toUpperCase()
	};

	axios
		.post(ApiConfig.url.SEARCH_POINT_OF_SALES, data, config)
		.then(function (result) {
			fn(result.data.accountListItems, result.data.totalPage, result.data.currentPage)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { SearchPointOfSalesCtrl };